import Vue from 'vue';
import VueResource from 'vue-resource';
import converterMoeda from '~js/converter-moeda';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

function normalizarParaSalvar(solicitacao) {
  delete solicitacao.projeto;
  delete solicitacao.dataPagamento;
  delete solicitacao.unidade;
  delete solicitacao.departamento;
  delete solicitacao.solicitante;

  solicitacao.itens = solicitacao.itens.map(item => {
    delete item.servicoProjeto;
    
    item.adicionalItem = item.adicionalItem ? converterMoeda.paraReal(item.adicionalItem) : ''; 
    item.valorItem = item.valorItem ? converterMoeda.paraReal(item.valorItem) : ''; 
    
    return item;
  });

  return solicitacao;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    const periodo = parametros.periodo;
    delete parametros.periodo;

    if (periodo) {
      parametros.dataInicio = moment(periodo[0], 'DD/MM/YYYY').format('MM/DD/YYYY');
      parametros.dataFim = moment(periodo[1], 'DD/MM/YYYY').format('MM/DD/YYYY');
    }

    return Vue.http.get('/api/solicitacaofaturamentomultiservicos', { params: parametros });
  },
  adicionar: (solicitacao, arquivos) => {
    solicitacao = normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;

    solicitacao = converterObjetoFormData(solicitacao);

    return Vue.http.post('/api/solicitacaofaturamentomultiservicos', solicitacao).then(res => res.data.id);
  },
  alterar: (solicitacao, arquivos, id) => {
    solicitacao = normalizarParaSalvar(solicitacao, id);
    solicitacao.arquivos = arquivos;

    solicitacao = converterObjetoFormData(solicitacao);
    
    return Vue.http.put(`/api/solicitacaofaturamentomultiservicos/${id}`, solicitacao).then(res => res.data.id);
  },
  obterPorId: id => {
    return Vue.http.get(`/api/solicitacaofaturamentomultiservicos/${id}`)
      .then(response => response.data);
  },
  liberar: id => {
    return Vue.http.post(`/api/solicitacaofaturamentomultiservicos/${id}/liberar`)
      .then(response => response.data);
  },
  cancelar: id => {
    return Vue.http.post(`/api/solicitacaofaturamentomultiservicos/${id}/cancelar`)
      .then(response => response.data);
  },
  reenviarEmail: id => {
    return Vue.http.get(`/api/solicitacaofaturamentomultiservicos/${id}/reenviaremail`)
      .then(response => response.data);
  },
  arquivos: id => {
    return Vue.http.get(`/api/solicitacaofaturamentomultiservicos/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/solicitacaofaturamentomultiservicos/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-faturamento-multiservicos/servico.js